import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Button, Dropdown, DropdownContent, type ITabItem, Tabs } from 'shared/ui'
import { TimezoneContent } from 'shared/ui/Schedule/ui/TimezoneContent/TimezoneContent'
import { SendLater } from 'shared/ui/Schedule/ui/SendLater'
import { type ICampaignScheduleType } from 'entities/Campaign'
import { useCampaignScheduleContext } from 'pages/campaigns/ui/CampaignSchedule/context/context'
import { campaignScheduleTypeTitle } from 'pages/campaigns/ui/CampaignSchedule/store/types'
import { DelayContent } from 'pages/campaigns/ui/CampaignSchedule/ui/DelayContent/DelayContent'
import { ScheduleDateFiled } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled'
import styles from './styles.module.scss'

export const CampaignScheduleUi = observer(() => {
  const {
    scheduleText,
    scheduleType,
    setScheduleType,
    sendLaterStore,
    scheduleDateFiledStore,
    is_contact_timezone,
  } = useCampaignScheduleContext()

  const tabKeys: ICampaignScheduleType[] = ['immediately', 'delay', 'date', 'date_field']
  const tabs: ITabItem<ICampaignScheduleType>[] = tabKeys.map((key) => ({
    key,
    name: campaignScheduleTypeTitle[key],
  }))

  const [previousScheduleType, setPreviousScheduleType] =
    useState<ICampaignScheduleType>('immediately')
  const handleSelectTab = (tab: ITabItem<ICampaignScheduleType>) => {
    setScheduleType(tab.key)
  }
  const onClose = () => {
    if (scheduleType === 'date_field' && !scheduleDateFiledStore.dateFiledKey) {
      setScheduleType(previousScheduleType)
    }
  }

  useEffect(() => {
    return () => {
      setPreviousScheduleType(scheduleType)
    }
  }, [scheduleType])

  return (
    <Dropdown
      triggerComponent={() => (
        <Button
          size={'medium'}
          contained={'secondary'}
          icon={'schedule'}
          text={scheduleText}
          secondaryRightContent={
            is_contact_timezone !== null && (
              <TimezoneContent is_contact_timezone={is_contact_timezone} />
            )
          }
        />
      )}
      onClose={onClose}
      placement={'bottom-start'}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              offset: ({ reference }) => {
                return [-8, -reference.height + -12]
              },
            },
          },
        ],
      }}
      customComponent={(_, dropdownId) => (
        <DropdownContent noPadding width={338}>
          <div className={styles.wrapTabs}>
            <Tabs
              tabs={tabs}
              activeTabKey={scheduleType}
              variant={'simpleWithoutBorder'}
              handleSelectTab={handleSelectTab}
            />
          </div>
          {scheduleType === 'delay' && <DelayContent dropdownId={dropdownId} />}
          {scheduleType === 'date' && (
            <div className={styles.wrapSendLater}>
              <SendLater dropdownId={dropdownId} store={sendLaterStore} />
            </div>
          )}
          {scheduleType === 'date_field' && (
            <ScheduleDateFiled store={scheduleDateFiledStore} dropdownId={dropdownId} />
          )}
        </DropdownContent>
      )}
    />
  )
})
